module.exports = __webpack_public_path__ + "img/icon_map_xg.6f8508e5.png";